import React from 'react';
import classNames from 'classnames/bind';
import styles from './PrivacyWarranty.module.scss';

const cx = classNames.bind(styles);

function PrivacyWarranty_02() {
	return (
		<div className={cx('terms')}>
			<dl className={cx('dl_type1', 'mt0')}>
				<dt>수집항목</dt>
				<dd>
					(필수) 이름, 생년월일, 휴대전화번호, 이메일, 주소, 사업자번호, 차량번호, 결제정보
					<br />
					(선택) 환불계좌(예금주, 은행명, 계좌번호)
				</dd>
				<dt>이용목적</dt>
				<dd>
					보증계약상 의무이행 목적(온라인 보증서 및 약관 송부, 계약 관리, 환불처리, 클레임 접수 및 대응, 보증 수리 진행, 수리이력 관리),
					본인확인, 분쟁조정을 위한 기록 보관, 고지사항 전달, 고객관리(서비스 만족도 조사)
				</dd>
				<dt>보유 및 이용 기간</dt>
				<dd>
					<em className={cx('font_bold', 'fs17')}>신청일로부터 5년</em>
					<br />
					단, 관계 법령에 따라 보존해야 하는 경우 관계 법령에서 정하는 기간까지 보존
				</dd>
			</dl>
			<p className={cx('pt20')}>
				* 고객님께서는 위의 항목에 동의를 거부할 권리가 있습니다. 단, 동의를 거부하실 경우 엔카보증 서비스 이용이 제한됩니다.
			</p>
		</div>
	);
}

export default PrivacyWarranty_02;
